/** Cookie 1st party espelhando `attribution_anonymous_id` (alinhado ao Max-Age do banner de cookies, 180d). */
export const ANON_ID_COOKIE_NAME = "astra_attribution_anon_id"
export const ANON_ID_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 180

export function isPlausibleAnonymousId(id: string): boolean {
  const t = id.trim()
  if (t.length < 8 || t.length > 128) return false
  if (/[\r\n;]/.test(t)) return false
  return true
}

/**
 * Lê o valor do cookie `name` a partir do string no formato `document.cookie`
 * (`"a=1; b=2"`).
 */
export function readIdFromDocumentCookie(cookieHeader: string, name = ANON_ID_COOKIE_NAME): string | null {
  if (!cookieHeader?.trim()) return null
  const parts = cookieHeader.split("; ")
  const prefix = `${name}=`
  for (const part of parts) {
    if (part.startsWith(prefix)) {
      const raw = part.slice(prefix.length)
      try {
        const v = decodeURIComponent(raw).trim()
        if (v && isPlausibleAnonymousId(v)) return v
      } catch {
        return null
      }
    }
  }
  return null
}

export function buildAnonymousIdSetCookieValue(
  id: string,
  maxAgeSeconds: number,
  isSecure: boolean,
): string {
  const safe = id.trim()
  return `${ANON_ID_COOKIE_NAME}=${encodeURIComponent(safe)}; Path=/; Max-Age=${maxAgeSeconds}; SameSite=Lax${isSecure ? "; Secure" : ""}`
}
